/* ==================================================
 *  Scripts
 * ==================================================*/

(function () {

  'use strict';

  $(document).on('click', '[data-media-collapse]', function (ev) {
    ev.preventDefault();

    var $this = $(this);
    var target = $this.attr('data-media-collapse');

    $(target).toggleClass('collapsed');
    $this.toggleClass('in');

    if ($this.hasClass('in')) {
      changeIcon($this, 'minus');
    } else {
      changeIcon($this, 'plus');
    }
  });

  function changeIcon(target, svg) {
    target.find('.icon').find('use').attr('xlink:href', '/svg/icons.svg#' + svg);
  }

})();
